import Vue from 'vue'

Vue.filter('humanTime', (date, relativeTime) => {
  // console.log(`input date - ${date}, relativeTime - ${relativeTime}`)
  // console.log(new Date(date))
  let milliseconds = 0
  if (relativeTime) {
    milliseconds = new Date().getTime() - new Date(date).getTime()
  } else {
    milliseconds = new Date(date).getTime()
  }

  function numberEnding (number) {
    return (number > 1) ? 's' : ''
  }

  let temp = Math.floor(milliseconds / 1000)
  const years = Math.floor(temp / 31536000)
  if (years) {
    return years + ' year' + numberEnding(years)
  }
  // TODO: Months! Maybe weeks?
  const days = Math.floor((temp %= 31536000) / 86400)
  if (days) {
    return days + ' day' + numberEnding(days)
  }
  const hours = Math.floor((temp %= 86400) / 3600)
  if (hours) {
    return hours + ' hour' + numberEnding(hours)
  }
  const minutes = Math.floor((temp %= 3600) / 60)
  if (minutes) {
    return minutes + ' minute' + numberEnding(minutes)
  }
  const seconds = temp % 60
  if (seconds) {
    return seconds + ' second' + numberEnding(seconds)
  }
  // 'just now' //or other string you like;
  return '0'
})
